import { GetActivePage, hasEmptyDatePlaceholder } from ".";
import saveState from "../../components/top-bar/top-bar-buttons/save-state/saveState";
import { addBackgroundImageToPage, changePagesBackgroundImage } from "../actions/entities/pages";
import { backgroundImageSelected } from "../actions/ui/backgroundImageSelected";
import { changeBookBackgroundColor, changeBookBackgroundImage } from "../actions/ui/bookProperties";
import Swal from 'sweetalert2';

//Background helper
function setBackgroundToAllBook(activePage, thumbnail, full, sizes, dispatch, coverType) {
    dispatch(addBackgroundImageToPage(activePage.id, activePage.order, thumbnail, full, sizes, coverType));
    dispatch(changeBookBackgroundColor(null));
    dispatch(changeBookBackgroundImage(thumbnail, full, sizes));
  }
  
  export function backgroundSet(thumbnail, full, pages, lang, sizes, props) {
    const setBg = () => setBackgroundToAllBook(activePage, thumbnail, full, sizes, props.dispatch, props.coverType);
    const {
      isBabyBook, pages: pagesByID, coverType, backgroundSelected, datePlaceholders,
    } = props;
    const activePage = Object.values(pages).find(element => element.isActive);
    const bookPages = Object.keys(pagesByID).length;
  
    if (isBabyBook || bookPages === 1) {
      return setBg();
    }
  
    const currentPage = GetActivePage(pages);
  
    if (!backgroundSelected) {
      setBg();
      props.handleBackgroundOpen();
      hasEmptyDatePlaceholder(currentPage, datePlaceholders.byId, lang);
      props.dispatch(backgroundImageSelected(true));
      return props.dispatch(saveState());
    }
  
  
    Swal({
      text: lang.color_change_question,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: lang.from_current,
      cancelButtonText: lang.from_first,
    }).then((result) => {
    	setBg();
      if (result.dismiss === Swal.DismissReason.cancel) {
        props.dispatch(changePagesBackgroundImage(thumbnail, full, sizes, coverType));
      }
      props.dispatch(backgroundImageSelected(true));
      props.handleBackgroundOpen();
  
      if (!backgroundSelected) {
        hasEmptyDatePlaceholder(currentPage, datePlaceholders.byId, lang);
      }
  
      //props.dispatch(saveState());
    });
  }


// WEBPACK FOOTER //
// ./src/redux/helpers/setBackground.jsx